import CryptoTiles from "assets/SelectGame/CrptoTiles.svg";
import TimeDice from "assets/SelectGame/TimeDice.png";
import RunPanda from "assets/SelectGame/RunPanda.svg";
import Surfers from "assets/SelectGame/3DSurfers.svg";

const SelectaGameContent = [
	{
		id: 1,
		title: "Crypto Tiles",
		body: "Match the Crypto tiles and earn real bitcoin.",
		image: CryptoTiles,
		gamePlay: "Play Now",
		url: "/crypto-tiles",
		enabled: true,
	},
	{
		id: 2,
		title: "Time Dice",
		body: "Train the brain with dice.",
		image: TimeDice,
		gamePlay: "Coming Soon",
		url: "/time-dice",
		enabled: false,
	},
	{
		id: 3,
		title: "Run Panda",
		body: "Super panda keep running to get his castle.",
		image: RunPanda,
		gamePlay: "Coming Soon",
		url: "/run-panda",
		enabled: false,
	},
	{
		id: 4,
		title: "3D Surfers",
		body: "Jump and skip the gaps to reach home.",
		image: Surfers,
		gamePlay: "Coming Soon",
		url: "/3d-surfers",
		enabled: false,
	},
];

export default SelectaGameContent;
